import React from 'react';
import CastColor from "./CastColor";

function DensityControl({ densityWindow, setDensityWindow, maxDuration }: { 
    densityWindow: number, 
    setDensityWindow: (val: number) => void,
    maxDuration: number
}) {
    return (
        <div className="flex items-center space-x-4 px-4 py-1 rounded border-l border-gray-200">
            <span className="text-xs font-bold text-gray-600 whitespace-nowrap">Density Window:</span>
            <input 
                type="range" 
                min="1" 
                max={Math.max(10, Math.ceil(maxDuration))} 
                value={densityWindow} 
                onChange={(e) => setDensityWindow(Number(e.target.value))}
                className="w-24 h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-blue-500"
            />
            <span className="text-xs font-mono text-gray-500 w-8 text-right">{densityWindow}s</span>
        </div>
    );
}

function PlaybackControl({ isPlaying, togglePlay, onSkip }: { 
    isPlaying: boolean, 
    togglePlay: () => void, 
    onSkip: (amount: number) => void 
}) {
    const btnClass = "px-3 py-1 bg-gray-100 hover:bg-gray-200 text-gray-700 text-xs font-bold rounded border border-gray-300 transition-colors";
    
    return (
        <div className="flex items-center space-x-2 px-4 border-l border-gray-200">
            <button className={btnClass} onClick={() => onSkip(-10)}>
                -10s
            </button>
            <button className={`${btnClass} w-16`} onClick={togglePlay}>
                {isPlaying ? "Pause" : "Play"}
            </button>
            <button className={btnClass} onClick={() => onSkip(10)}>
                +10s
            </button>
        </div>
    );
}

function CastSetting(props: any) {
    const updateColors = (newcolors: any) => {
        props.setChartColors(newcolors);
    }
    return (
        <div className="bg-white border-b shadow-sm z-40 sticky top-0">
            <div className="flex flex-col md:flex-row justify-center items-center space-y-2 md:space-y-0 md:space-x-4 p-2">
                <CastColor colors={props.colors} updateColors={updateColors}/>
                
                {/* Density Control */}
                <div className="pt-2 md:pt-0 md:pl-4">
                    <DensityControl 
                        densityWindow={props.densityWindow} 
                        setDensityWindow={props.setDensityWindow} 
                        maxDuration={props.maxDuration} 
                    />
                </div>

                {/* Playback Control */}
                <div className="pt-2 md:pt-0 md:pl-4">
                     <PlaybackControl 
                        isPlaying={props.isPlaying}
                        togglePlay={props.togglePlay}
                        onSkip={props.onSkip}
                     />
                </div>
            </div>
        </div>
    )
}

export default CastSetting;